import { Button } from "primereact/button"
import { Card } from "primereact/card"
import { Trans } from "react-i18next"
import PatientsSuccessChart from "./patientsSuccessChart"
import { useEffect, useState, useMemo } from "react"
import HomeCarusel from "./homeCarusel"


const TopCards = ({ ongoingPlanListData, t }: any) => {

    const [caruselData, setCaruselData] = useState<any>([]);
    const [caruselIndex, setCaruselIndex] = useState<any>(0);

    const completedCount = useMemo(() => {
        if (!ongoingPlanListData?.planList) return "0";
        
        const distinctPatients = new Set<string>();
        
        ongoingPlanListData.planList.forEach((plan: any) => {
            const adherenceList = plan.exercisesAdheranceList;
            if (!adherenceList || adherenceList.length === 0) return;
            
            const lastEntry = adherenceList[adherenceList.length - 1];
            if (lastEntry?.averageSuccessStatus?.toLowerCase() !== "missed") {
                const patientKey = `${plan.patientFirstName || ""}_${plan.patientLastName || ""}`;
                distinctPatients.add(patientKey);
            }
        });
        
        return distinctPatients.size.toString();
    }, [ongoingPlanListData]);

    const totalCount = useMemo(() => {
        if (!ongoingPlanListData?.planList) return "0";
        
        const distinctPatients = new Set<string>();
        
        ongoingPlanListData.planList.forEach((plan: any) => {
            const patientKey = `${plan.patientFirstName || ""}_${plan.patientLastName || ""}`;
            distinctPatients.add(patientKey);
        });
        
        return distinctPatients.size.toString();
    }, [ongoingPlanListData]);

    const averagePercentage = useMemo(() => {
        if (!ongoingPlanListData?.planList) return "0";
        
        const successRates: number[] = [];
        
        ongoingPlanListData.planList.forEach((plan: any) => {
            const adherenceList = plan.exercisesAdheranceList;
            if (!adherenceList || adherenceList.length === 0) return;
            
            const lastEntry = adherenceList[adherenceList.length - 1];
            if (lastEntry?.averageSuccessStatus?.toLowerCase() !== "missed" && 
                lastEntry?.averageSuccessRate != null) {
                successRates.push(Number(lastEntry.averageSuccessRate));
            }
        });
        
        if (successRates.length === 0) return "0";
        
        const average = successRates.reduce((sum, rate) => sum + rate, 0) / successRates.length;
        return Math.round(average).toString();
    }, [ongoingPlanListData]);

    useEffect(() => {

        if (ongoingPlanListData) {
            setCaruselData(
                [
                    {
                        img: "/activePatientsIcon.svg",
                        title: 'activePatients',
                        value: completedCount,
                    },
                    {
                        img: "/completedPlansIcon.svg",
                        title: 'completedPlans',
                        value: ongoingPlanListData.completedPlans,
                    },
                    {
                        img: "/patientAdherenceIcon.svg",
                        title: 'patientAdherence',
                        value: ongoingPlanListData.patientAdherance ? Math.round(ongoingPlanListData.patientAdherance) : "0",
                    },
                    {
                        img: "/averageExerciseDuration.svg",
                        title: 'averageExerciseDuration',
                        value: ongoingPlanListData.averageExerciseDuration,
                    },
                    {
                        img: "/newPatientsIcon.svg",
                        title: 'newPatients',
                        value: ongoingPlanListData.newPatients,
                    },
                    {
                        img: "/missedPlansIcon.svg",
                        title: 'missedPlans',
                        value: ongoingPlanListData.missedPlans,
                    }
                ]
            );

        }

    }, [ongoingPlanListData]);

    return (
        <>
            <Card className='w-full lg:w-8' style={{
                borderRadius: "24px", position: "relative",
                backgroundImage: "url('/homeCardBackgroung.png')",
                minWidth: "30rem",
            }}>
                <div className='flex flex-column gap-4'>
                    <p className='m-0' style={{ color: "#FFFFFF" }}>{t("activePatients")}</p>
                    <div>
                        <p className='m-0 text-4xl' style={{ color: "#FFFFFF" }}>
                            <Trans
                                i18nKey="adherenceReport"
                                values={{
                                    completed: completedCount,
                                    total: totalCount,
                                    percentage: averagePercentage
                                }}
                                components={{ br: <br /> }}
                            />
                        </p>
                    </div>
                </div>

            </Card>
            <Card className='w-full lg:w-3 flex justify-content-center align-items-center'
                style={{
                    borderRadius: "24px", position: "relative", minWidth: "20rem"
                }}>
                <PatientsSuccessChart t={t} percentage={averagePercentage} />
            </Card>

            <Card className='w-full lg:w-3 '
                style={{
                    borderRadius: "24px", position: "relative", minWidth: "20rem"
                }}>
                <HomeCarusel caruselData={caruselData} t={t} caruselIndex={caruselIndex} setCaruselIndex={setCaruselIndex} />
            </Card>
        </>
    )
}

export default TopCards;